<div class="header__logo hidden-sm-down">
  <h1><a routerLink="/">{{ 'global.header.title' | translate }}</a></h1>
</div>